import { NgModule } from '@angular/core';
import { SiteWideDialogComponent } from './site-wide-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { GlobalUIComponentsModule } from '../../ui-components/global/global-ui-components.module';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'shared';

@NgModule({
    declarations: [
        SiteWideDialogComponent
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        GlobalUIComponentsModule,
        PipesModule
    ],
    exports: [
        SiteWideDialogComponent
    ],
    entryComponents: [
        SiteWideDialogComponent
    ]
})
export class SiteWideDalogModule { }
